import { render, staticRenderFns } from "./weekly-add-or-update.vue?vue&type=template&id=8a147dde&scoped=true&"
import script from "./weekly-add-or-update.vue?vue&type=script&lang=js&"
export * from "./weekly-add-or-update.vue?vue&type=script&lang=js&"
import style0 from "./weekly-add-or-update.vue?vue&type=style&index=0&id=8a147dde&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a147dde",
  null
  
)

export default component.exports